import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import cx from 'classnames';
import React, { useRef } from 'react';
import { useId } from '../hooks/use-id.js';
export var FormInputText = function FormInputText(_ref) {
  var _cx;

  var className = _ref.className,
      externallyControlled = _ref.externallyControlled,
      disabled = _ref.disabled,
      id = _ref.id,
      inputRef = _ref.inputRef,
      leading = _ref.leading,
      name = _ref.name,
      readOnly = _ref.readOnly,
      selectOnFocus = _ref.selectOnFocus,
      trailing = _ref.trailing,
      value = _ref.value,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      rest = _objectWithoutProperties(_ref, ["className", "externallyControlled", "disabled", "id", "inputRef", "leading", "name", "readOnly", "selectOnFocus", "trailing", "value", "variant"]);

  var uId = useId();
  var htmlId = id || uId;
  var willSelectOnFocus = selectOnFocus !== null && selectOnFocus !== void 0 ? selectOnFocus : readOnly;
  var fallbackRef = useRef(null);
  var ref = inputRef || fallbackRef;
  return React.createElement("div", {
    className: cx('tds-form-input', (_cx = {}, _defineProperty(_cx, "tds-form-input--".concat(variant), variant), _defineProperty(_cx, 'tds-form-input--readonly', readOnly), _defineProperty(_cx, 'tds--disabled', disabled), _cx), className),
    onClick: function onClick(e) {
      var _a, _b, _c; // Autofocus input when outer div is clicked


      if (!e.target.closest('button, .tds-tooltip-wrapper') || willSelectOnFocus) {
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus(); // Auto-select text within the input when focused

        if (willSelectOnFocus && !((_b = document.getSelection()) === null || _b === void 0 ? void 0 : _b.toString().length)) {
          (_c = ref.current) === null || _c === void 0 ? void 0 : _c.select();
        }
      }
    }
  }, leading && React.createElement("div", {
    className: "tds-form-input-leading"
  }, leading), React.createElement("input", _objectSpread({
    className: "tds-form-input-text",
    id: htmlId,
    name: name,
    readOnly: externallyControlled || readOnly,
    ref: ref,
    value: value,
    disabled: disabled
  }, rest)), trailing && React.createElement("div", {
    className: "tds-form-input-trailing"
  }, trailing));
};